import {Params} from '@feathersjs/feathers'

import {ProviderCertification, ProviderId} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'providerCertification'

const get = async (params?: Params) => feathersService.find<ProviderCertification>(RESOURCE, params)

export const getByProvider = async (provider: ProviderId) => {
  const parameters = {
    query: {
      provider,
    },
  }
  return get(parameters)
}

export const create = async (payload: Omit<ProviderCertification, 'id'>) =>
  feathersService.create<ProviderCertification, Omit<ProviderCertification, 'id'>>(
    RESOURCE,
    payload
  )

export const createMultiple = async (payload: Omit<ProviderCertification, 'id'>[]) =>
  payload.length > 0
    ? feathersService.createMultiple<ProviderCertification, Omit<ProviderCertification, 'id'>>(
        RESOURCE,
        payload
      )
    : Promise.resolve([])

export const remove = async (id: string) =>
  feathersService.remove<ProviderCertification>(RESOURCE, id)

export const removeMultiple = async (ids: string[]) => Promise.all(ids.map(id => remove(id)))
